module.exports = __webpack_public_path__ + "img/undraw_Balloons_re_8ymj.a27bb51f.svg";